import React, { useState, useEffect } from "react";
import { UseAdvertisments } from "./UseAdvertisments";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";

export default function AdvertismentsAutoComplete(props) {
  const { getAllAdvertismentList } = UseAdvertisments();
  const [advertismentRes, setAdvertismentRes] = useState();
  const [selectedAdvertisment, setSelectedAdvertisment] = useState();

  useEffect(() => {
    getAllAdvertismentList((items) => {
      setAdvertismentRes(items);
    });
  }, []);

  useEffect(() => {
    if (!props.selectedAdvertismentID) {
      setSelectedAdvertisment();
    }
  }, [props.selectedAdvertismentID]);

  useEffect(() => {
    if (advertismentRes && props.selectedAdvertismentID) {
      setSelectedAdvertisment(
        advertismentRes.items.find((m) => m.id == props.selectedAdvertismentID)
      );
    }
  }, [advertismentRes, props.selectedAdvertismentID]);

  useEffect(() => {
    if (selectedAdvertisment) {
      if (props.contract) {
        props.setState({
          ...props.state,
          advertismentID: selectedAdvertisment.id,
          title: selectedAdvertisment.title,
        });
        return;
      }
      props.setState({
        ...props.state,
        advertismentID: selectedAdvertisment.id,
      });
    }
  }, [selectedAdvertisment]);

  return advertismentRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.contract && "70%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedAdvertisment ? selectedAdvertisment : ""}
        options={advertismentRes.items ? advertismentRes.items : []}
        getOptionLabel={(items) => (items.title ? items.title : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.errorState} {...params} label="تبلیغ" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.title ? option.title : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedAdvertisment(newValue);
          } else {
            setSelectedAdvertisment();
            props.setState({
              ...props.state,
              advertismentID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllAdvertismentList((items) => {
            setAdvertismentRes(items);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/advertisments" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
